module.exports = __webpack_public_path__ + "img/seguridad.5c7ad78a.png";